import React from 'react';
import { aboutData } from '../data';
import { motion } from 'framer-motion';
import { plateVariants, staggerContainer, fadeIn } from '../variants';

const About = () => {

  const { pretitle, title, subtitle, btnText, image } =aboutData;
  return (
    <section id='wanna know about us?' className='cursor-default overflow-hidden min-h-[100vh]'>
      <div className='container mx-auto min-h-[100vh] my-8'>

        <motion.div 
        variants={staggerContainer}
        initial='hidden'
        whileInView={'show'}
        viewport={{once: false, amount: 0.2}} 
        className='min-h-[100vh] flex flex-col lg:flex-row items-center'>
          
          <motion.div 
          variants={fadeIn('right', 'tween', 0.2, 1.6)} 
          className='flex-1 text-center lg:text-left'>
            <div className='pretitle'>{pretitle}</div>
            <h2 className='h2 capitalize'>{title}</h2>
            <p className='mb-5 max-w-[560px]'>{subtitle}</p>
            <a href="tel:+94716418542"><button className='btn mx-auto lg:mx-0'>{btnText}</button></a>
          </motion.div>

          <motion.div 
          variants={plateVariants} 
          className='-mr-[30px] z-10'>
            <img className='w-[500px]' src={image} alt=''/>
          </motion.div>
        </motion.div>

      </div>
    </section>
  );
};

export default About;
